var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.shouldShow)?_c('FloatingActionButton',{staticClass:"back-to-top",attrs:{"id":_vm.id,"icon":['fas', 'arrow-up'],"tooltip-wording":"Back to Top","type":"custom"},on:{"toggled":_vm.scrollToTop}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }